module.exports = __webpack_public_path__ + "static/media/back_star.ecd8a6bc.png";